import settings from '../../config/settings';
import axiosNonAuth from './axiosNonAuth';

const {apiBaseUrl} = settings;

export default class PostalCodeApi {
  static lookupByIP() {
    return axiosNonAuth.get(`${apiBaseUrl}/postal-codes/lookup-by-ip/`);
  }
}
